import {Role} from './models/users/user.model';

export const ModuleNames = [
  'POS_MODULE',
  'PRODUCTS_MODULE',
  'ACCOUNTS_MODULE',
  'USER_MODULE',
  'SHIPPING_MODULE',
  'PAYMENTS_MODULE',
  'REFRIGERATOR_MODULE',
  'PROCESS_FLOW_MODULE',
  'ENGINE_MODULE',
  'LABOUR_MODULE',
  'CREDIT_NOTE_MODULE',
  'STOCK_MODULE',
  'SUBSCRIPTION_MODULE',
  'ANALYTICS_MODULE',
  'LOGGING_MODULE',
  'DOCUMENT_MODULE',
  'XERO_MODULE',
  'JOB_STATUS_MODULE'
] as const;

export type Modules = typeof ModuleNames[number];

export const NavigationItems: Record<Modules, NavigationGroup> = {
  POS_MODULE: {
    name: 'InvFlow',
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_USER'],
    order: 1,
    items: [
      {
        name: 'Quotes',
        icon: 'assignment',
        route: 'pos/quote'
      },
      {
        name: 'Invoices',
        icon: 'assignment_turned_in',
        route: 'pos/invoice/job'
      },
      {
        name: 'Search',
        icon: 'search',
        route: 'pos/search'
      },
    ]
  },
  ACCOUNTS_MODULE: {
    name: 'Accounts',
    order: 3,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_USER'],
    items: [
      {
        name: 'Debtors',
        icon: 'people',
        route: 'account/debtors'
      },
      {
        name: 'Creditors',
        icon: 'people_outline',
        route: 'account/creditors'
      },
    ]
  },
  CREDIT_NOTE_MODULE: {
    name: 'Credit Notes',
    order: 4,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Credit Notes',
        icon: 'request_quote',
        route: 'credit/notes',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
      }
    ]
  },
  PRODUCTS_MODULE: {
    name: 'Products',
    order: 5,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Products',
        icon: 'shopping_cart',
        route: 'products'
      },
    ]
  },
  USER_MODULE: {
    name: 'Users',
    order: 6,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Users',
        icon: 'people',
        route: 'users'
      }
    ]
  },
  SHIPPING_MODULE: {
    name: 'Shipping',
    order: 7,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Providers',
        icon: 'app_settings_alt',
        route: 'shipping/providers'
      },
      {
        name: 'Orders',
        icon: 'local_shipping',
        route: 'shipping/orders'
      }
    ]
  },
  PAYMENTS_MODULE: {
    name: 'Payments',
    order: 8,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Providers',
        icon: 'payment',
        route: 'payments/providers'
      },

    ]
  },
  REFRIGERATOR_MODULE: {
    name: 'Refrigerators',
    order: 9,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Units',
        icon: 'ac_unit',
        route: 'refrigerator/units'
      },
      {
        name: 'Components',
        icon: 'room_preferences',
        route: 'refrigerator/components'
      },
    ]
  },
  PROCESS_FLOW_MODULE: {
    name: 'Process Flows',
    order: 10,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_PROCESS_FLOW_SIGN_OFF', 'ROLE_PROCESS_USER'],
    items: [
      {
        name: 'Flows',
        icon: 'account_tree',
        route: 'process/flow/process',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
      },
      {
        name: 'Current Flows',
        icon: 'engineering',
        route: 'process/flow/job',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_PROCESS_FLOW_SIGN_OFF'],
      },
      {
        name: 'Completed Flows',
        icon: 'task',
        route: 'process/flow/completed',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_PROCESS_FLOW_SIGN_OFF'],
      },
      {
        name: 'My processes',
        icon: 'engineering',
        route: 'process/flow/my-processes',
        role: ['ROLE_PROCESS_USER'],
      }
    ]
  },
  ENGINE_MODULE: {
    name: 'Engines',
    order: 11,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Engines',
        icon: 'garage',
        route: 'engine',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
      }
    ]
  },
  LABOUR_MODULE: {
    name: 'Labour',
    order: 12,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Labour',
        icon: 'precision_manufacturing',
        route: 'labour',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
      }
    ]
  },
  STOCK_MODULE: {
    name: 'Stock',
    order: 13,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_USER'],
    items: [
      {
        name: 'Stock',
        icon: 'inventory_2',
        route: 'stock',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_USER'],
      }
    ]
  },
  SUBSCRIPTION_MODULE: {
    name: 'Subscription',
    order: 14,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
    items: [
      {
        name: 'Subscriptions',
        icon: 'currency_exchange',
        route: 'subscription',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER'],
      }
    ]
  },
  ANALYTICS_MODULE: {
    name: 'Analytics',
    order: 15,
    role: ['ROLE_ANALYTICS'],
    items: [
      {
        name: 'View Analytics',
        icon: 'analytics',
        route: 'analytics',
        role: ['ROLE_ANALYTICS']
      }
    ]
  },
  DOCUMENT_MODULE: {
    name: 'Documents',
    order: 16,
    role: ['ROLE_DOCUMENT'],
    items: [
      {
        name: 'Document Viewer',
        icon: 'folder_open',
        route: 'documents/viewer',
        role: ['ROLE_ADMIN', 'ROLE_DOCUMENT']
      },
    ]
  },
  LOGGING_MODULE: {
    name: 'Logs',
    order: 17,
    role: ['ROLE_ADMIN', 'ROLE_LOGGING'],
    items: [
      {
        name: 'View Logs',
        icon: 'list',
        route: 'logs',
        role: ['ROLE_ADMIN', 'ROLE_LOGGING']
      }
    ]
  },
  XERO_MODULE: {
    name: 'Xero',
    order: 18,
    role: ['ROLE_ADMIN', 'ROLE_ACCOUNTANT'],
    items: [
      {
        name: 'Configuration',
        icon: 'settings',
        route: 'xero/configuration',
        role: ['ROLE_ADMIN'],
      },
      {
        name: 'Connect',
        icon: 'link',
        route: 'xero/connect',
        role: ['ROLE_ADMIN', 'ROLE_ACCOUNTANT'],
      },
      {
        name: 'Sync Logs',
        icon: 'history',
        route: 'xero/sync-logs',
        role: ['ROLE_ADMIN'],
      }
    ]
  },
  JOB_STATUS_MODULE: {
    name: 'Job Status',
    order: 2,
    role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_JOB_STATUS'],
    items: [
      {
        name: 'Overview',
        icon: 'fact_check',
        route: 'job/status',
        role: ['ROLE_ADMIN', 'ROLE_SYSTEM_USER', 'ROLE_JOB_STATUS'],
      },
      {
        name: 'Statuses',
        icon: 'settings',
        route: 'job/status/configurations',
        role: ['ROLE_ADMIN'],
      }
    ]
  }
};

export interface NavigationGroup {
  name: string;
  order: number;
  items: NavigationItem[];
  role: Role[];
}

export interface NavigationItem {
  name: string;
  route: string;
  icon: string;
  role?: Role[];
}
